import { PrimaryButton, Spacing, TimeFormat } from 'ia-react-core';
import React, { FC, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import { ReactComponent as ErrorIcon } from '../../assets/Robot-error.svg';
import ApplicationAvailabilityContext from '../../components/ApplicationAvailability/ApplicationAvailabilityContext';
import redirectTo from '../../utils/redirectTo';
import {
  StyledErrorMessage, StyledIcon, StyledParagraph,
  StyledTitle, StyledWrapper, StyledActionBar,
} from '../ErrorPages.styles';
import { validateAvailability } from '../../utils/validateAvailability';

export interface UnavailablePageProps {
  homePagePath: string;
  group: string;
  company: '0' | '6';
  experience: 'CLIENT' | 'ADVISOR' | 'EMPLOYEE';
}

const UnavailablePage: FC<UnavailablePageProps> = ({ homePagePath, group, company, experience }) => {
  const { t } = useTranslation('UnavailablePage');
  const { search } = useLocation();
  const groupCode = new URLSearchParams(search).get('group');
  const context = useContext(ApplicationAvailabilityContext);
  const history = useHistory();

  useEffect(() => {
    if (groupCode) return;
    validateAvailability(group, company, experience)
      .then((availability) => {
        if (availability.isAvailable) redirectTo(homePagePath, history);
      })
      .finally(() => { /* */ });
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <StyledWrapper>
      <StyledErrorMessage>
        <StyledIcon as={ErrorIcon} />
        <StyledTitle data-testid="unavailableErrorTitle">{t('title')}</StyledTitle>
        <StyledParagraph>
          {t('message')}
        </StyledParagraph>
        {
          context?.availability?.unavailableUntil &&
          <Spacing m-t={12}>
            <StyledParagraph>
              {t('unavailableUntil')}
              <TimeFormat time={context?.availability?.unavailableUntil} isDateWithTime />
            </StyledParagraph>
          </Spacing>
        }
        {
          groupCode &&
          <StyledActionBar>
            <PrimaryButton onClick={() => redirectTo(homePagePath, history)}>{t('homeButton')}</PrimaryButton>
          </StyledActionBar>
        }
      </StyledErrorMessage>
    </StyledWrapper>
  );
};
export default UnavailablePage;
